import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-badge-up', 'IconArrowBadgeUp', [
  ['path', { d: 'M17 11v6l-5 -4l-5 4v-6l5 -4z', key: 'svg-0' }],
]);
